"use client";

import * as Input from "../../components/Form/Input";
import { PasswordInput } from "../../components/password-input";
import { Button } from "../../components/Button";
import { useAuth } from "../../hook/auth";
import { useCallback, useEffect, useState } from "react";
import { useStore } from "../../store";
import { Link, useNavigate } from "react-router-dom";
import {
  AuthLayout,
  authCardClass,
  authLinkClass,
  authIconClass,
  authDividerLineClass,
  authTitleClass,
  authSubtitleClass,
} from "../../components/auth-layout";
import { AuthBrand, AuthMobileLogoShell } from "../../components/auth-brand";
import { Mail, Lock } from "lucide-react";

export function SignIn() {
  const { signIn } = useAuth();
  const user = useStore((store) => store.user);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    async (e: React.FormEvent) => {
      e.preventDefault();
      await signIn({ email, password });
    },
    [email, password, signIn]
  );

  useEffect(() => {
    if (user.id) {
      navigate("/inicio");
    }
  }, [user.id, navigate]);

  return (
    <AuthLayout>
      <AuthMobileLogoShell>
        <AuthBrand className="h-11 w-auto max-w-[min(100%,260px)] object-contain" />
      </AuthMobileLogoShell>

      <div className="mb-8 hidden lg:flex justify-center">
        <AuthBrand className="h-12 w-auto max-w-[min(100%,280px)] object-contain" />
      </div>
      <div className={authCardClass}>

        <div className="mb-8 text-center">
          <h1 className={authTitleClass}>Acesse sua conta</h1>
          <p className={authSubtitleClass}>
            Painel APCAP Brasil — entre com seu e-mail e senha
          </p>
        </div>

        <form className="space-y-5" onSubmit={handleSubmit} noValidate>
          <div>
            <label
              htmlFor="email"
              className="mb-1.5 flex items-center gap-2 text-sm font-medium text-zinc-800"
            >
              <Mail className={`h-4 w-4 ${authIconClass}`} />
              E-mail
            </label>
            <Input.Root variant="auth">
              <Input.Control
                name="email"
                id="email"
                type="email"
                autoComplete="email"
                placeholder="seu@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Input.Root>
          </div>

          <div>
            <div className="mb-1.5 flex items-center justify-between gap-2">
              <label
                htmlFor="password"
                className="flex items-center gap-2 text-sm font-medium text-zinc-800"
              >
                <Lock className={`h-4 w-4 ${authIconClass}`} />
                Senha
              </label>
              <Link to="/esqueci-senha" className={`text-xs ${authLinkClass}`}>
                Esqueci a senha
              </Link>
            </div>
            <PasswordInput
              name="password"
              id="password"
              variant="auth"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <Button
            type="submit"
            variant="brand"
            className="h-11 w-full font-medium"
          >
            Entrar
          </Button>
        </form>

        <div className="relative my-8">
          <div className="absolute inset-0 flex items-center">
            <span className={`w-full ${authDividerLineClass}`} />
          </div>
          <div className="relative flex justify-center text-[11px] font-semibold uppercase tracking-[0.14em] text-zinc-400">
            <span className="bg-white px-3">ou</span>
          </div>
        </div>

        <Button
          type="button"
          variant="brandOutline"
          className="h-11 w-full font-medium"
          onClick={() => navigate("/cadastro")}
        >
          Criar conta
        </Button>
      </div>
    </AuthLayout>
  );
}
